import { getSrc } from 'gatsby-plugin-image'
import React from 'react'

import * as styles from './header-background-v2.module.scss'

type Props = {
  image: {
    gatsbyImageData: Record<string, unknown> | null
    alt: string | null
  } | null
  title: string
  headline: string
}

const HeaderBackgroundV2: React.FC<Props> = (props) => {
  const { image, title, headline } = props
  const imageSrc = image?.gatsbyImageData ? getSrc(image?.gatsbyImageData) : ''
  return (
    <div
      className={styles.header}
      style={{
        backgroundImage: `url(${imageSrc})`
      }}
    >
      <div className={styles.headerText}>
        <div className="container">
          <div className="row">
            <div className="col-lg-8 pr-4">
              <h1>{title}</h1>
              <div className={styles.subtitle}>{headline}</div>
            </div>
            <div className="col-lg-5" />
          </div>
        </div>
      </div>
    </div>
  )
}

export default HeaderBackgroundV2
